export default class ArticleBody {
	private articleSummary: HTMLElement | null
	private articleSummaryList: HTMLElement | null
	private articleSummaryItemsCount: number | null
	private articleSummaryButtons: NodeListOf<HTMLElement> | null

	constructor() {
		this.articleSummary = document.querySelector('.articleSummary')
		this.articleSummaryList = this.articleSummary?.querySelector('.articleSummary-list') ?? null
		this.articleSummaryItemsCount = this.articleSummaryList?.children.length ?? null
		this.articleSummaryButtons =
			this.articleSummary?.querySelectorAll('.articleSummary-btn') ?? null

		this.handleToggleClick = this.handleToggleClick.bind(this)
	}

	init(): void {
		this.addEvents()

		if (this.articleSummaryItemsCount && this.articleSummaryItemsCount > 4) {
			this.activateArticleSummary()
		}
	}

	private addEvents(): void {
		if (this.articleSummaryButtons) {
			this.articleSummaryButtons.forEach((button) => {
				button.addEventListener('click', this.handleToggleClick)
			})
		}
	}

	private handleToggleClick(): void {
		this.toggleVisible()
	}

	private toggleVisible(): void {
		this.articleSummary?.classList.toggle('visible')
	}

	private activateArticleSummary(): void {
		this.articleSummary?.classList.add('active')
	}
}
